/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Update per-share access level and/or hidden modules.
 * @export
 * @interface UpdateClaimAccessRequest
 */
export interface UpdateClaimAccessRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateClaimAccessRequest
     */
    accessLevel?: UpdateClaimAccessRequestAccessLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateClaimAccessRequest
     */
    blockedModules?: Array<UpdateClaimAccessRequestBlockedModulesEnum>;
}


/**
 * @export
 */
export const UpdateClaimAccessRequestAccessLevelEnum = {
    Ro: 'ro',
    Rw: 'rw'
} as const;
export type UpdateClaimAccessRequestAccessLevelEnum = typeof UpdateClaimAccessRequestAccessLevelEnum[keyof typeof UpdateClaimAccessRequestAccessLevelEnum];

/**
 * @export
 */
export const UpdateClaimAccessRequestBlockedModulesEnum = {
    Comparisons: 'comparisons',
    Documents: 'documents',
    Photos: 'photos',
    Links: 'links',
    Tasks: 'tasks',
    Supplements: 'supplements',
    Forms: 'forms',
    Financials: 'financials',
    Emails: 'emails',
    Notes: 'notes'
} as const;
export type UpdateClaimAccessRequestBlockedModulesEnum = typeof UpdateClaimAccessRequestBlockedModulesEnum[keyof typeof UpdateClaimAccessRequestBlockedModulesEnum];


/**
 * Check if a given object implements the UpdateClaimAccessRequest interface.
 */
export function instanceOfUpdateClaimAccessRequest(value: object): value is UpdateClaimAccessRequest {
    return true;
}

export function UpdateClaimAccessRequestFromJSON(json: any): UpdateClaimAccessRequest {
    return UpdateClaimAccessRequestFromJSONTyped(json, false);
}

export function UpdateClaimAccessRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClaimAccessRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'accessLevel': json['accessLevel'] == null ? undefined : json['accessLevel'],
        'blockedModules': json['blockedModules'] == null ? undefined : json['blockedModules'],
    };
}

export function UpdateClaimAccessRequestToJSON(json: any): UpdateClaimAccessRequest {
    return UpdateClaimAccessRequestToJSONTyped(json, false);
}

export function UpdateClaimAccessRequestToJSONTyped(value?: UpdateClaimAccessRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'accessLevel': value['accessLevel'],
        'blockedModules': value['blockedModules'],
    };
}

